import React, { createContext } from 'react';
import { Provider } from 'react-redux';
import ActionCable from "actioncable";

import configureStore from '../store/confirmAttendeesStore';
import ConfirmAttendeesContainer from '../containers/ConfirmAttendeesContainer';

const CableApp = {};
CableApp.cable = ActionCable.createConsumer('/cable');
const ActionCableContext = createContext();

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const ConfirmAttendeesApp = (props) => (
  <Provider store={configureStore(props)}>
    <ActionCableContext.Provider value={CableApp}>
      <ConfirmAttendeesContainer />
    </ActionCableContext.Provider>
  </Provider>
);

export default ConfirmAttendeesApp;
export { ActionCableContext };
